<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    work
                </mat-icon>
                <span>
                    Role: {{ itemEnvelope?.ItemId }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <mat-form-field appearance="outline">
                    <mat-label>Role UID</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Unique ID" [(ngModel)]="itemEnvelope.Document.Item.UID" />
                </mat-form-field>
                <br />
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input matInput *ngIf="itemEnvelope" name="Description" placeholder="Description" [(ngModel)]="itemEnvelope.Document.Item.Description" />
                </mat-form-field>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

